import { render, staticRenderFns } from "./ApprovalMessageCard.vue?vue&type=template&id=37906fae&scoped=true"
import script from "./ApprovalMessageCard.vue?vue&type=script&lang=js"
export * from "./ApprovalMessageCard.vue?vue&type=script&lang=js"
import style0 from "./ApprovalMessageCard.vue?vue&type=style&index=0&id=37906fae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37906fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37906fae')) {
      api.createRecord('37906fae', component.options)
    } else {
      api.reload('37906fae', component.options)
    }
    module.hot.accept("./ApprovalMessageCard.vue?vue&type=template&id=37906fae&scoped=true", function () {
      api.rerender('37906fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImChat/components/ApprovalMessageCard.vue"
export default component.exports